import { c as _c } from "react/compiler-runtime";
import { HotelReserveCardContent } from "@website/accommodation-ui/hotel-reserve-rooms-layout/hotel-reserve-card/hotel-reserve-card-content";
import { HotelReserveCardFooter } from "@website/accommodation-ui/hotel-reserve-rooms-layout/hotel-reserve-card/hotel-reserve-card-footer";
import { HotelReserveCardFullCapacity } from "@website/accommodation-ui/hotel-reserve-rooms-layout/hotel-reserve-card/hotel-reserve-card-full-capacity";
import { HotelReserveCardRacks } from "@website/accommodation-ui/hotel-reserve-rooms-layout/hotel-reserve-card/hotel-reserve-card-racks";
import { useHotelReserveCard } from "@website/accommodation-ui/hotel-reserve-rooms-layout/hotel-reserve-card/hotel-reserve-card.hook";
import { HotelReservedCardPropertiesType } from "@website/accommodation-ui/hotel-reserve-rooms-layout/hotel-reserve-card/hotel-reserve-card.types";
export const HotelReserveCard = properties => {
  const $ = _c(17);
  const {
    availableRooms,
    rackIncluded
  } = properties;
  const {
    hotelReserveCardContentProps,
    hotelReserveCardFooterProps,
    hotelReserveCardFullCapacityProps,
    hotelReserveCardRacksProps,
    reference
  } = useHotelReserveCard(properties);
  let t0;
  if ($[0] !== hotelReserveCardContentProps) {
    t0 = <HotelReserveCardContent {...hotelReserveCardContentProps} />;
    $[0] = hotelReserveCardContentProps;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="bg-outline-thin h-px w-full" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== availableRooms || $[4] !== hotelReserveCardFooterProps || $[5] !== hotelReserveCardFullCapacityProps || $[6] !== rackIncluded) {
    t2 = availableRooms || rackIncluded ? <HotelReserveCardFooter {...hotelReserveCardFooterProps} /> : <HotelReserveCardFullCapacity {...hotelReserveCardFullCapacityProps} />;
    $[3] = availableRooms;
    $[4] = hotelReserveCardFooterProps;
    $[5] = hotelReserveCardFullCapacityProps;
    $[6] = rackIncluded;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t0 || $[9] !== t2) {
    t3 = <div className="flex flex-row"><div className="w-min grow">{t0}{t1}{t2}</div></div>;
    $[8] = t0;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== hotelReserveCardRacksProps) {
    t4 = <HotelReserveCardRacks {...hotelReserveCardRacksProps} />;
    $[11] = hotelReserveCardRacksProps;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== reference || $[14] !== t3 || $[15] !== t4) {
    t5 = <div className="bg-on-color-high-emphasis shadow-1 flex min-w-[218px] flex-col overflow-hidden rounded-xl xl:max-w-[1104px]" ref={reference}>{t3}{t4}</div>;
    $[13] = reference;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
};